export interface Color {
    hue: number,
    saturation: number,
    lightness: number,
    alpha ? : number
};

export interface Stroke {
    color: Color,
    width ? : number,
    dash ? : number[],
    cap ? : string
};

export interface ViewBox {
    minX: number,
    minY: number,
    width: number,
    height: number
};

export interface SVGRoot {
    content: string,
    viewBox: ViewBox, 
}

export const wrapInSVG = ( svgRoot: SVGRoot ) => `<svg viewBox="${svgRoot.viewBox.minX} ${svgRoot.viewBox.minY} ${svgRoot.viewBox.width} ${svgRoot.viewBox.height}" preserveAspectRatio="xMinYMin slice" style="width:100%; height:100%; position:absolute;">${svgRoot.content}</svg>`;
